<template>
    <div>

        <div class="tutoring-item" v-if="tutoring.status == 2">
            <div class="tutoring-item-left">
                <div class="title mb-5" data-bs-toggle="modal" :data-bs-target="'#tutoringDetailModal'+tutoring.id">[{{tutoring.class_name}}] - {{tutoring.desc}}</div>
                <div class="mb-5">
                    <span class="s-text">{{tutoring.time_start | convertUnitToTime('HH:mm')}}</span> {{$t('to')}} <span class="s-text">{{tutoring.time_end | convertUnitToTime('HH:mm')}}</span> 
                    <template v-if="tutoring.is_live">- {{$t('live_now')}} <span class="tutoring-live-now"></span></template>
                </div>
                <div class="mb-5"><b>{{$t('teacher')}}:</b> <span class="u-text">{{tutoring.teacher}}</span></div>
                <div>
                    {{$t('attendees')}}: {{tutoring.current_student}}/{{tutoring.max_student}}
                    <div class="progress">
                        <div class="progress-bar" v-if="tutoring.current_student < tutoring.max_student" :style="{'width':(100*tutoring.current_student/tutoring.max_student)+'%'}"></div>
                        <div class="progress-bar full" v-else style="width: 100%;"></div>
                    </div>
                </div>
            </div>
            <div class="tutoring-item-right">
                <button class="btn btn-lisa-1" @click = "join_class(tutoring)" data-bs-toggle="modal" :data-bs-target="'#tutoringDetailModal'+tutoring.id">{{$t('button_join_class')}}</button>
            </div>

            <div class="modal tutoring-modal fade modal-flex" :id="'tutoringDetailModal'+tutoring.id" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="welcomeBackModal" aria-hidden="true">
                <div class="modal-dialog" style="width: 510px; max-width: 510px;">
                    <div class="modal-content" style="padding-bottom: 15px;">
                        <div class="modal-header">
                            <h5 class="modal-title" id="staticBackdropLabel">[{{tutoring.class_name}}] - {{tutoring.desc}}</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <div class="tutoring-modal-body">
                                <div class="tutoring-modal-left">
                                    <div class="mb-8"><i class="lisa-icon-tutoring-1 mr-8"></i> {{$t('teacher')}}: <b>{{tutoring.teacher}}</b></div>
                                    <div class="mb-8"><i class="lisa-icon-tutoring-2 mr-8"></i> {{$t('time')}}: <b>{{tutoring.time_start | convertUnitToTime('HH:mm')}} - {{tutoring.time_end | convertUnitToTime('HH:mm, DD MMM, YYYY')}}</b></div>
                                    <div class="mb-8"><i class="lisa-icon-tutoring-3 mr-8"></i> {{$t('description')}}:</div>
                                </div>
                                <div class="tutoring-modal-right">
                                    <div class="mb-8"><i class="lisa-icon-tutoring-5 mr-8"></i> {{$t('grade')}}: <b>{{tutoring.grade}}</b></div>
                                    <div class="mb-8"><i class="lisa-icon-tutoring-6 mr-8"></i> {{$t('subject')}}: <b>{{tutoring.subject}}</b></div>
                                    <div class="mb-8"><i class="lisa-icon-tutoring-7 mr-8"></i> {{$t('attendees')}}: <b>{{tutoring.current_student}}/{{tutoring.max_student}}</b></div>
                                </div>
                            </div>
                            <div class="mb-8">
                                {{tutoring.desc}}
                            </div>
                            <!--<div><i class="lisa-icon-tutoring-4 mr-8"></i> Registration time: <b>08:00 - 10:00, 30 Sep, 2021</b></div>-->

                            <div class="text-center" style="margin-top: 28px;">
                                <button class="btn btn-lisa-1 mb-5" @click = "join_class(tutoring)">{{$t('button_join_class')}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
                        
        </div>
        
        <div class="tutoring-item tutoring-item-1" v-else-if="tutoring.status == 1">
            <div class="tutoring-item-left">
                <div class="title mb-5" data-bs-toggle="modal" :data-bs-target="'#tutoringDetailModal'+tutoring.id">[{{tutoring.class_name}}] - {{tutoring.desc}}</div>
                <div class="mb-5">
                    <span class="s-text">{{tutoring.time_start | convertUnitToTime('HH:mm')}}</span> {{$t('to')}} <span class="s-text">{{tutoring.time_end | convertUnitToTime('HH:mm')}}</span> 
                    <template v-if="tutoring.is_live">
                        - {{$t('live_now')}} <span class="tutoring-live-now"></span>
                    </template>                    
                </div>
                <div class="mb-5"><b>{{$t('teacher')}}:</b> <span class="u-text">{{tutoring.teacher}}</span></div>
                <div>
                    {{$t('attendees')}}: {{tutoring.current_student}}/{{tutoring.max_student}}
                    <div class="progress">
                        <div class="progress-bar" v-if="tutoring.current_student < tutoring.max_student" :style="{'width':(100*tutoring.current_student/tutoring.max_student)+'%'}"></div>
                        <div class="progress-bar full" v-else style="width: 100%;"></div>
                    </div>
                </div>
            </div>
            <div class="tutoring-item-right">
                <button class="btn btn-lisa-2 mb-5" @click="subscribe(tutoring)" data-bs-toggle="modal" :data-bs-target="'#tutoringDetailModal'+tutoring.id">{{$t('register')}}</button>
                <div>{{$t('from')}} <b>{{tutoring.subscribe_from | convertUnitToTime('HH:mm')}}</b> {{$t('to')}} <b>{{tutoring.subscribe_to | convertUnitToTime('HH:mm')}}</b>, {{tutoring.subscribe_to | convertUnitToTime('DD MMM, YYYY')}}</div>
            </div>

            <div class="modal tutoring-modal fade modal-flex" :id="'tutoringDetailModal'+tutoring.id" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="welcomeBackModal" aria-hidden="true">
                <div class="modal-dialog" style="width: 510px; max-width: 510px;">
                    <div class="modal-content" style="padding-bottom: 15px;">
                        <div class="modal-header">
                            <h5 class="modal-title" id="staticBackdropLabel">[{{tutoring.class_name}}] - {{tutoring.desc}}</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <div class="tutoring-modal-body">
                                <div class="tutoring-modal-left">
                                    <div class="mb-8"><i class="lisa-icon-tutoring-1 mr-8"></i> {{$t('teacher')}}: <b>{{tutoring.teacher}}</b></div>
                                    <div class="mb-8"><i class="lisa-icon-tutoring-2 mr-8"></i> {{$t('time')}}: <b>{{tutoring.time_start | convertUnitToTime('HH:mm')}} - {{tutoring.time_end | convertUnitToTime('HH:mm, DD MMM, YYYY')}}</b></div>
                                    <div class="mb-8"><i class="lisa-icon-tutoring-3 mr-8"></i> {{$t('description')}}:</div>
                                </div>
                                <div class="tutoring-modal-right">
                                    <div class="mb-8"><i class="lisa-icon-tutoring-5 mr-8"></i> {{$t('grade')}}: <b>{{tutoring.grade}}</b></div>
                                    <div class="mb-8"><i class="lisa-icon-tutoring-6 mr-8"></i> {{$t('subject')}}: <b>{{tutoring.subject}}</b></div>
                                    <div class="mb-8"><i class="lisa-icon-tutoring-7 mr-8"></i> {{$t('attendees')}}: <b>{{tutoring.current_student}}/{{tutoring.max_student}}</b></div>
                                </div>
                            </div>
                            <div class="mb-8">
                                {{tutoring.desc}}
                            </div>
                            <div><i class="lisa-icon-tutoring-4 mr-8"></i> {{$t('registration_time')}}: <b>{{tutoring.subscribe_from | convertUnitToTime('HH:mm')}} - {{tutoring.subscribe_to | convertUnitToTime('HH:mm DD MMM, YYYY')}}</b></div>

                            <div class="text-center" style="margin-top: 28px;">
                                <button class="btn btn-lisa-2 mb-5" @click="subscribe(tutoring)">{{$t('register')}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="tutoring-item tutoring-item-1" v-else-if="tutoring.status == 0 || tutoring.status == 6 || tutoring.status == 7">
            <div class="tutoring-item-left">
                <div class="title mb-5" data-bs-toggle="modal" :data-bs-target="'#tutoringDetailModal'+tutoring.id">[{{tutoring.class_name}}] - {{tutoring.desc}}</div>
                <div class="mb-5">
                    <span class="s-text">{{tutoring.time_start | convertUnitToTime('HH:mm')}}</span> {{$t('to')}} <span class="s-text">{{tutoring.time_end | convertUnitToTime('HH:mm')}}</span> 
                    <template v-if="tutoring.is_live">
                        - {{$t('live_now')}} <span class="tutoring-live-now"></span>
                    </template>                    
                </div>
                <div class="mb-5"><b>{{$t('teacher')}}:</b> <span class="u-text">{{tutoring.teacher}}</span></div>
                <div>
                    {{$t('attendees')}}: {{tutoring.current_student}}/{{tutoring.max_student}}
                    <div class="progress">
                        <div class="progress-bar" v-if="tutoring.current_student < tutoring.max_student" :style="{'width':(100*tutoring.current_student/tutoring.max_student)+'%'}"></div>
                        <div class="progress-bar full" v-else style="width: 100%;"></div>
                    </div>
                </div>
            </div>
            <div class="tutoring-item-right">
                <button class="btn btn-lisa-2 mb-5 unregister" data-bs-toggle="modal" :data-bs-target="'#tutoringDetailModal'+tutoring.id">{{$t('register')}}</button>
                <div>{{$t('from')}} <b>{{tutoring.subscribe_from | convertUnitToTime('HH:mm')}}</b> {{$t('to')}} <b>{{tutoring.subscribe_to | convertUnitToTime('HH:mm')}}</b>, {{tutoring.subscribe_to | convertUnitToTime('DD MMM, YYYY')}}</div>
            </div>

            <div class="modal tutoring-modal fade modal-flex" :id="'tutoringDetailModal'+tutoring.id" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="welcomeBackModal" aria-hidden="true">
                <div class="modal-dialog" style="width: 510px; max-width: 510px;">
                    <div class="modal-content" style="padding-bottom: 15px;">
                        <div class="modal-header">
                            <h5 class="modal-title" id="staticBackdropLabel">[{{tutoring.class_name}}] - {{tutoring.desc}}</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <div class="tutoring-modal-body">
                                <div class="tutoring-modal-left">
                                    <div class="mb-8"><i class="lisa-icon-tutoring-1 mr-8"></i> {{$t('teacher')}}: <b>{{tutoring.teacher}}</b></div>
                                    <div class="mb-8"><i class="lisa-icon-tutoring-2 mr-8"></i> {{$t('time')}}: <b>{{tutoring.time_start | convertUnitToTime('HH:mm')}} - {{tutoring.time_end | convertUnitToTime('HH:mm, DD MMM, YYYY')}}</b></div>
                                    <div class="mb-8"><i class="lisa-icon-tutoring-3 mr-8"></i> {{$t('description')}}:</div>
                                </div>
                                <div class="tutoring-modal-right">
                                    <div class="mb-8"><i class="lisa-icon-tutoring-5 mr-8"></i> {{$t('grade')}}: <b>{{tutoring.grade}}</b></div>
                                    <div class="mb-8"><i class="lisa-icon-tutoring-6 mr-8"></i> {{$t('subject')}}: <b>{{tutoring.subject}}</b></div>
                                    <div class="mb-8"><i class="lisa-icon-tutoring-7 mr-8"></i> {{$t('attendees')}}: <b>{{tutoring.current_student}}/{{tutoring.max_student}}</b></div>
                                </div>
                            </div>
                            <div class="mb-8">
                                {{tutoring.desc}}
                            </div>
                            <div><i class="lisa-icon-tutoring-4 mr-8"></i> {{$t('registration_time')}}: <b>{{tutoring.subscribe_from | convertUnitToTime('HH:mm')}} - {{tutoring.subscribe_to | convertUnitToTime('HH:mm DD MMM, YYYY')}}</b></div>

                            <div class="text-center" style="margin-top: 28px;">
                                <button class="btn btn-lisa-2 mb-5" disabled>{{$t('register')}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>        

        <div class="tutoring-item tutoring-item-4" v-else-if="tutoring.status == 5">
            <div class="tutoring-item-left">
                <div class="title mb-5" data-bs-toggle="modal" :data-bs-target="'#tutoringDetailModal'+tutoring.id">[{{tutoring.class_name}}] - {{tutoring.desc}}</div>
                <div class="mb-5">
                    <span class="s-text">{{tutoring.time_start | convertUnitToTime('HH:mm')}}</span> {{$t('to')}} <span class="s-text">{{tutoring.time_end | convertUnitToTime('HH:mm')}}</span> 
                    <template v-if="tutoring.is_live">
                        - {{$t('live_now')}} <span class="tutoring-live-now"></span>
                    </template> 
                </div>
                <div class="mb-5"><b>{{$t('teacher')}}:</b> <span class="u-text">{{tutoring.teacher}}</span></div>
                <div>
                    {{$t('attendees')}}: {{tutoring.current_student}}/{{tutoring.max_student}}
                    <div class="progress">
                        <div class="progress-bar" v-if="tutoring.current_student < tutoring.max_student" :style="{'width':(100*tutoring.current_student/tutoring.max_student)+'%'}"></div>
                        <div class="progress-bar full" v-else style="width: 100%;"></div>
                    </div>
                </div>
            </div>
            <div class="tutoring-item-right">
                <button class="btn btn-lisa-5 mb-5" data-bs-toggle="modal" :data-bs-target="'#tutoringDetailModal'+tutoring.id">{{$t('button_full_slot')}}</button>
            </div>

            <div class="modal tutoring-modal fade modal-flex" :id="'tutoringDetailModal'+tutoring.id" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="welcomeBackModal" aria-hidden="true">
                <div class="modal-dialog" style="width: 510px; max-width: 510px;">
                    <div class="modal-content" style="padding-bottom: 15px;">
                        <div class="modal-header">
                            <h5 class="modal-title" id="staticBackdropLabel">[{{tutoring.class_name}}] - {{tutoring.desc}}</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <div class="tutoring-modal-body">
                                <div class="tutoring-modal-left">
                                    <div class="mb-8"><i class="lisa-icon-tutoring-1 mr-8"></i> {{$t('teacher')}}: <b>{{tutoring.teacher}}</b></div>
                                    <div class="mb-8"><i class="lisa-icon-tutoring-2 mr-8"></i> {{$t('time')}}: <b>{{tutoring.time_start | convertUnitToTime('HH:mm')}} - {{tutoring.time_end | convertUnitToTime('HH:mm, DD MMM, YYYY')}}</b></div>
                                    <div class="mb-8"><i class="lisa-icon-tutoring-3 mr-8"></i> {{$t('description')}}:</div>
                                </div>
                                <div class="tutoring-modal-right">
                                    <div class="mb-8"><i class="lisa-icon-tutoring-5 mr-8"></i> {{$t('grade')}}: <b>{{tutoring.grade}}</b></div>
                                    <div class="mb-8"><i class="lisa-icon-tutoring-6 mr-8"></i> {{$t('subject')}}: <b>{{tutoring.subject}}</b></div>
                                    <div class="mb-8"><i class="lisa-icon-tutoring-7 mr-8"></i> {{$t('attendees')}}: <b>{{tutoring.current_student}}/{{tutoring.max_student}}</b></div>
                                </div>
                            </div>
                            <div class="mb-8">
                                {{tutoring.desc}}
                            </div>
                            <div><i class="lisa-icon-tutoring-4 mr-8"></i> {{$t('registration_time')}}: <b>{{tutoring.subscribe_from | convertUnitToTime('HH:mm')}} - {{tutoring.subscribe_to | convertUnitToTime('HH:mm DD MMM, YYYY')}}</b></div>

                            <div class="text-center" style="margin-top: 28px;">
                                <button class="btn btn-lisa-5 mb-5">{{$t('button_full_slot')}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <div class="tutoring-item tutoring-item-2" v-else-if="tutoring.status == 3">
            <div class="tutoring-item-left">
                <div class="title mb-5" data-bs-toggle="modal" :data-bs-target="'#tutoringDetailModal'+tutoring.id">[{{tutoring.class_name}}] - {{tutoring.desc}}</div>
                <div class="mb-5">
                    <span class="s-text">{{tutoring.time_start | convertUnitToTime('HH:mm')}}</span> {{$t('to')}} <span class="s-text">{{tutoring.time_end | convertUnitToTime('HH:mm')}}</span> 
                    <template v-if="tutoring.is_live">
                        - {{$t('live_now')}} <span class="tutoring-live-now"></span>
                    </template> 
                </div>
                <div class="mb-5"><b>{{$t('teacher')}}:</b> <span class="u-text">{{tutoring.teacher}}</span></div>
                <div>
                    {{$t('attendees')}}: {{tutoring.current_student}}/{{tutoring.max_student}}
                    <div class="progress">
                        <div class="progress-bar" v-if="tutoring.current_student < tutoring.max_student" :style="{'width':(100*tutoring.current_student/tutoring.max_student)+'%'}"></div>
                        <div class="progress-bar full" v-else style="width: 100%;"></div>
                    </div>
                </div>
            </div>
            <div class="tutoring-item-right">
                <button class="btn btn-lisa-3 mb-5"><countdown :time = "tutoring.time_start" /></button>
            </div>

            <div class="modal tutoring-modal fade modal-flex" :id="'tutoringDetailModal'+tutoring.id" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="welcomeBackModal" aria-hidden="true">
                <div class="modal-dialog" style="width: 510px; max-width: 510px;">
                    <div class="modal-content" style="padding-bottom: 15px;">
                        <div class="modal-header">
                            <h5 class="modal-title">[{{tutoring.class_name}}] - {{tutoring.desc}}</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <div class="tutoring-modal-body">
                                <div class="tutoring-modal-left">
                                    <div class="mb-8"><i class="lisa-icon-tutoring-1 mr-8"></i> {{$t('teacher')}}: <b>{{tutoring.teacher}}</b></div>
                                    <div class="mb-8"><i class="lisa-icon-tutoring-2 mr-8"></i> {{$t('time')}}: <b>{{tutoring.time_start | convertUnitToTime('HH:mm')}} - {{tutoring.time_end | convertUnitToTime('HH:mm, DD MMM, YYYY')}}</b></div>
                                    <div class="mb-8"><i class="lisa-icon-tutoring-3 mr-8"></i> {{$t('description')}}:</div>
                                </div>
                                <div class="tutoring-modal-right">
                                    <div class="mb-8"><i class="lisa-icon-tutoring-5 mr-8"></i> {{$t('grade')}}: <b>{{tutoring.grade}}</b></div>
                                    <div class="mb-8"><i class="lisa-icon-tutoring-6 mr-8"></i> {{$t('subject')}}: <b>{{tutoring.subject}}</b></div>
                                    <div class="mb-8"><i class="lisa-icon-tutoring-7 mr-8"></i> {{$t('attendees')}}: <b>{{tutoring.current_student}}/{{tutoring.max_student}}</b></div>
                                </div>
                            </div>
                            <div class="mb-8">
                                {{tutoring.desc}}
                            </div>
                            <div><i class="lisa-icon-tutoring-4 mr-8"></i> {{$t('registration_time')}}: <b>{{tutoring.subscribe_from | convertUnitToTime('HH:mm')}} - {{tutoring.subscribe_to | convertUnitToTime('HH:mm DD MMM, YYYY')}}</b></div>

                            <div class="text-center" style="margin-top: 28px;">
                                <button class="btn btn-lisa-2 mb-5" @click = "unsubscribeVerify(tutoring)">{{$t('button_cancel_registration')}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade modal-tutoring modal-flex" :id="'tutoringDetailModal'+tutoring.id" tabindex="-1" role="dialog" aria-labelledby="registerModal" aria-hidden="true" data-backdrop="static" data-keyboard=false>
                <div class="modal-dialog modal-dialog-centered popup-main-1" role="document" style="width: 380px; text-align: center;">
                    <div class="modal-content box-shadow-main">
                        <div class="d-flex">
                            <h4 class="title text-center" style="width: 100%; margin-left: 9px;">{{$t('button_cancel_registration')}}</h4>
                            <div class="close-popup" data-dismiss="modal"></div>
                        </div>

                        <div style="margin: 25px auto;">{{$t('cancel_registration_question')}}</div>

                        <div>
                            <button class="btn btn-register-class disable btn-class-2" data-dismiss="modal" style="margin-right: 20px;">{{$t('no')}}</button>
                            <button class="btn btn-register-class btn-class-2" @click="unsubscribe(tutoring)">{{$t('yes')}}</button>
                        </div>
                    </div>
                </div>
            </div>               

        </div>

        <div class="tutoring-item tutoring-item-3" v-else-if="tutoring.status == 4">
            <div class="tutoring-item-left">
                <div class="title mb-5" data-bs-toggle="modal" :data-bs-target="'#tutoringDetailModal'+tutoring.id">[{{tutoring.class_name}}] - {{tutoring.desc}}</div>
                <div class="mb-5">
                    <span class="s-text">{{tutoring.time_start | convertUnitToTime('HH:mm')}}</span> {{$t('to')}} <span class="s-text">{{tutoring.time_end | convertUnitToTime('HH:mm')}}</span> 
                    <template v-if="tutoring.is_live">
                        - {{$t('live_now')}} <span class="tutoring-live-now"></span>
                    </template> 
                </div>
                <div class="mb-5"><b>{{$t('teacher')}}:</b> <span class="u-text">{{tutoring.teacher}}</span></div>
                <div>
                    {{$t('attendees')}}: {{tutoring.current_student}}/{{tutoring.max_student}}
                    <div class="progress">
                        <div class="progress-bar" v-if="tutoring.current_student < tutoring.max_student" :style="{'width':(100*tutoring.current_student/tutoring.max_student)+'%'}"></div>
                        <div class="progress-bar full" v-else style="width: 100%;"></div>
                    </div>
                </div>
            </div>
            <div class="tutoring-item-right">
                <button class="btn btn-lisa-4 mb-5" data-bs-toggle="modal" :data-bs-target="'#tutoringDetailModal'+tutoring.id">{{$t('button_finished')}}</button>
            </div>

            <div class="modal tutoring-modal fade modal-flex" :id="'tutoringDetailModal'+tutoring.id" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="welcomeBackModal" aria-hidden="true">
                <div class="modal-dialog" style="width: 510px; max-width: 510px;">
                    <div class="modal-content" style="padding-bottom: 15px;">
                        <div class="modal-header">
                            <h5 class="modal-title">[{{tutoring.class_name}}] - {{tutoring.desc}}</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <div class="tutoring-modal-body">
                                <div class="tutoring-modal-left">
                                    <div class="mb-8"><i class="lisa-icon-tutoring-1 mr-8"></i> {{$t('teacher')}}: <b>{{tutoring.teacher}}</b></div>
                                    <div class="mb-8"><i class="lisa-icon-tutoring-2 mr-8"></i> {{$t('time')}}: <b>{{tutoring.time_start | convertUnitToTime('HH:mm')}} - {{tutoring.time_end | convertUnitToTime('HH:mm, DD MMM, YYYY')}}</b></div>
                                    <div class="mb-8"><i class="lisa-icon-tutoring-3 mr-8"></i> {{$t('description')}}:</div>
                                </div>
                                <div class="tutoring-modal-right">
                                    <div class="mb-8"><i class="lisa-icon-tutoring-5 mr-8"></i> {{$t('grade')}}: <b>{{tutoring.grade}}</b></div>
                                    <div class="mb-8"><i class="lisa-icon-tutoring-6 mr-8"></i> {{$t('subject')}}: <b>{{tutoring.subject}}</b></div>
                                    <div class="mb-8"><i class="lisa-icon-tutoring-7 mr-8"></i> {{$t('attendees')}}: <b>{{tutoring.current_student}}/{{tutoring.max_student}}</b></div>
                                </div>
                            </div>
                            <div class="mb-8">
                                {{tutoring.desc}}
                            </div>

                            <div class="text-center" style="margin-top: 28px;">
                                <button class="btn btn-lisa-4 mb-5">{{$t('button_finished')}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>

    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from "axios";
import { tutoringSubscribe } from "../../models/tutoring";
import { joinClass } from "../../models/tutoring";
import { convertSecondToText } from "../../utils/utils";
import Countdown from '../element/Countdown.vue';

export default {
  components: { Countdown },
    name: "TutoringItem",

    props: ['tutoring'],

    computed: {
        ...mapGetters([
            'user_info'
        ], () => {
            if (this.user_info) {
                return this.user_info
            }

            return {
                gem: 0
            }
        })
    },

    data() {
        return {
            register_time_start: ""
        };
    },

    created() {
        this.countdown = this.tutoring.time_end;
    },

    methods: {
        join_class(tutoring) {
            const that = this;

            that.$store.commit("setLoading", true);

            joinClass({
                id: tutoring.id
            }).then((response) => {
                that.$store.commit("setLoading", false);

                if (response.data.code != 0) {
                    return;
                }

                $('#tutoringDetailJoinClassModal'+tutoring.id).modal("hide");
                window.open(response.data.results.link, '_blank');
                that.$emit('updateTutoring', 'join_class', tutoring, response.data.results);
            }).catch(({ response }) => {
                that.$store.commit("setLoading", false);

                console.error(response);
            });
        },

        subscribe(tutoring) {
            const that = this;

            that.$store.commit("setLoading", true);

            tutoringSubscribe({
                id: tutoring.id
            }).then((response) => {
                that.$store.commit("setLoading", false);

                if (response.data.code != 0) {
                    return;
                }

                $('#tutoringRegisterModal' + tutoring.id).modal("hide");

                that.$emit('updateTutoring', 'subscribe', tutoring, response.data.results);
            }).catch(({ response }) => {
                that.$store.commit("setLoading", false);

                console.error(response);
            });
        },

        unsubscribeVerify(tutoring) {
            $('#tutoringDetailCancelRegistrationModal'+tutoring.id).modal('hide');
            $('#tutoringDetailCancelRegistrationVerifyModal'+tutoring.id).modal();
        },

        unsubscribe(tutoring) {
            const that = this;

            that.$store.commit("setLoading", true);

            tutoringSubscribe({
                id: tutoring.id
            }).then((response) => {
                that.$store.commit("setLoading", false);

                if (response.data.code != 0) {
                    return;
                }

                $('#tutoringDetailCancelRegistrationVerifyModal'+tutoring.id).modal('hide');

                that.$emit('updateTutoring', 'unsubscribe', tutoring, response.data.results);
            }).catch(({ response }) => {
                that.$store.commit("setLoading", false);

                console.error(response);
            });
        },
        
        showDetailModal(tutoring){
            $('#tutoringDetailModal'+tutoring.id).modal('show');
        }
    }
}
</script>

<style scoped>

</style>
